import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {cloneObject, getParam} from '../utils/utils';
import {listResources} from '../utils/utilsResource';


import dsd from "../classes/clsDSD";

import { Plus, Trash } from 'react-bootstrap-icons';

class ResourceRow extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: 'loading'
        };


        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleButton = this.handleButton.bind(this);


        this.dsd = new dsd();

        this.FallBackNavigation = `.`;


    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    setup(){

        let StateChange = {

            renderState: 'loading',

            FormData: {},

            Resource: null,
            seq: null,

            onAdd: null,
            onRemove: null,
            onUpdate: null,
            onMoveUp: null,
            onMoveDown: null,

            optResources:null,

            getResource:false,
            selectedResource:null
        }

        StateChange.mode = getParam('mode', this.props) || 'edit';
        StateChange.onAdd = getParam('onAdd', this.props);
        StateChange.onRemove = getParam('onRemove', this.props);
        StateChange.onUpdate = getParam('onUpdate', this.props);
        StateChange.onMoveUp = getParam('onMoveUp', this.props);
        StateChange.onMoveDown = getParam('onMoveDown', this.props);

        StateChange.Resource = getParam('Resource', this.props);
        if (isNull(StateChange.Resource)){
            StateChange.Resource = {};
        }
        StateChange.seq = getParam('seq', this.props);

        StateChange.FormData = StateChange.Resource;

        this.setState(StateChange);
        this.loadResources();
        
    }

    loadResources(){

        listResources(
            this.dsd,
            {},
            (data) => {
                let selectedResource = null;
                if (this.state.Resource && this.state.Resource.idResource) {
                    for (let pos = 0; pos < data.length; pos++) {
                        if (data[pos].id == this.state.Resource.idResource) {
                            selectedResource = data[pos];
                        }
                    }
                }
                this.setState({
                    optResources: data,
                    selectedResource: selectedResource,
                    FormData: this.state.Resource,
                    renderState: 'loaded'
                });
            },
            (error) => {
                this.setState({
                    renderState: 'failed',
                    errorMessage: error.message || 'Failed to load resources'
                });
            }
        );

    }

    handleButton(event) {
    
        let StateChange = {};

        switch (event.currentTarget.name){
            case 'btnAdd':               
                StateChange.mode = 'edit';
                if (this.state.onAdd){
                    this.state.onAdd();
                    break;
                }
                break;
            case 'btnDelete':
                if (this.state.onRemove){
                    this.state.onRemove(this.state.seq);
                    break;
                }
                break;
        }
    
        this.setState(StateChange);
    
        event.preventDefault();    

    };


    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;
        this.setState({FormData: FormData});

        if (this.state.onUpdate){
            this.state.onUpdate(this.state.seq, FormData);
        }


    };

    render() {

        if (this.state.renderState === 'failed') {
            return <PD.ErrorBox>ERROR - Failed to Load</PD.ErrorBox>
        }


        if (this.state.renderState === 'loaded') {

            switch (this.state.mode){
                case 'new':
                case 'edit':
                    return (
                        <PD.Tr>
                            <PD.Td>
                                {(() => {
                                    switch (this.state.mode) {
                                        case "new": 
                                            return <button name="btnAdd" onClick={this.handleButton}><Plus/></button>;
                                        case "edit": 
                                            return <button name="btnDelete" onClick={this.handleButton}><Trash/></button>;
                                    }
                                })()}
                            </PD.Td>
                            {this.state.mode == 'edit' &&
                                <React.Fragment>
                                    <PD.Td>

                                        <PD.Select label='Resource' name='idResource'  onChange={this.handleChange} value={this.state.FormData.idResource}>
                                            {
                                                this.state.optResources.map(
                                                (optResource, posOptResource) => 
                                                    {
                                                        let optModelResource = null;
                                                        if (optResource.type in this.dsd.model.resources){
                                                            optModelResource = this.dsd.model.resources[optResource.type];
                                                        }
                                                        return (
                                                            <option key={posOptResource} value={optResource.id}>{optResource.name}</option>
                                                        )
                                                    }
                                                )
                                            }
                                        </PD.Select>
                                        <PD.Input label='relevance' name="relevance" width="30" value={this.state.FormData.relevance} onChange={this.handleChange}/>
                                        <PD.Input label='URL' name="URL" width="30" value={this.state.FormData.URL} onChange={this.handleChange}/>
                                    </PD.Td>

                                </React.Fragment>
                            }
                        </PD.Tr>
                    );
                    break;
            };
        };

        return null;
    };
};

// Wrap and export
export default function ResourceRow_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ResourceRow {...props} navigation={navigation} location={location} params={params} />;
  }
